import { render, staticRenderFns } from "./PagePoint.vue?vue&type=template&id=0195fb1c&scoped=true"
import script from "./PagePoint.vue?vue&type=script&lang=js"
export * from "./PagePoint.vue?vue&type=script&lang=js"
import style0 from "./PagePoint.vue?vue&type=style&index=0&id=0195fb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195fb1c",
  null
  
)

export default component.exports